import { createFileRoute } from "@tanstack/react-router"

import { AuthPage } from "@/components/auth-page.js"

export const Route = createFileRoute("/_auth/signup")({
  component: () => <AuthPage mode="signup" />,
})
